import { Card, Slot, Anchor, Image, Text, Heading } from '@costar-ui/components';
import React from 'react';

var ArticleCard = function ArticleCard(_ref) {
  var article = _ref.article;
  var paddingX = article.leadMediaUrl ? '2xl' : 'none';
  return /*#__PURE__*/React.createElement(Card, {
    direction: "horizontal",
    bordered: false,
    className: "basis-3/6"
  }, /*#__PURE__*/React.createElement(Card.Body, {
    direction: "horizontal",
    paddingX: "none",
    paddingY: "none"
  }, article.leadMediaUrl && /*#__PURE__*/React.createElement(Slot, {
    canShrink: false,
    fullHeight: true
  }, /*#__PURE__*/React.createElement(Anchor, {
    variant: "secondary",
    direction: "vertical",
    alignItems: "start",
    className: "inline-block",
    onClick: article.onClick,
    href: article.url
  }, /*#__PURE__*/React.createElement(Image, {
    src: article.leadMediaUrl,
    width: 180,
    height: 120,
    className: "max-w-none"
  }))), /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical",
    alignItems: "start",
    gap: "xs",
    paddingX: paddingX
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "text-12"
  }, article.publishDate), /*#__PURE__*/React.createElement(Anchor, {
    variant: "inherit",
    direction: "vertical",
    alignItems: "start",
    onClick: article.onClick,
    href: article.url
  }, /*#__PURE__*/React.createElement(Heading, {
    variant: "heading-18",
    className: "font-serif",
    ellipsis: "2"
  }, article.title)), /*#__PURE__*/React.createElement(Text, {
    color: "neutral-bold",
    ellipsis: "2",
    variant: "news-text-16"
  }, article.summary))));
};

export { ArticleCard };
//# sourceMappingURL=article-card.esm.js.map
